import $ from 'jquery';

export let ctrlKeyDown = false;
export let shiftKeyDown = false;

$(document).on('keydown keyup', event => {
    ctrlKeyDown = event.ctrlKey;
    shiftKeyDown = event.shiftKey;
});
